import { createContext, useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import getApiInstance from "../services/api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [system, setSystem] = useState(null);
  const [parameters, setParameters] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Verificar se já existe uma sessão
    const storedToken = localStorage.getItem("token");
    const storedUser = localStorage.getItem("user");
    const storedSystem = localStorage.getItem("system");
    const storedParameters = localStorage.getItem("parameters");

    if (storedToken && storedUser && storedSystem && storedParameters) {
      setToken(storedToken);
      setUser(JSON.parse(storedUser));
      setParameters(JSON.parse(storedParameters));
      setSystem(storedSystem);
    }

    setLoading(false);
  }, []);

  const login = async (credentials, selectedSystem) => {
    try {
      setLoading(true);
      const api = getApiInstance(selectedSystem);
      const response = await api.post("/login", {
        nick: credentials.login,
        senha: credentials.password,
      });

      const { token, user, tef, message } = response.data;

      if (!token) {
        throw new Error(message || "Falha na autenticação");
      }

      if (!tef) {
        throw new Error("TEF não habilitado para este usuário");
      }

      // para sisfuner
      const funerariaTef = "0" + tef.Funeraria?.replace(/[^0-9]/g, "") - 0;
      if (funerariaTef && funerariaTef !== 0) {
        throw new Error(
          `TEF associado ao usuário não pode estar vinculado a uma funerária ${funerariaTef}`
        );
      }

      user.tef = tef;

      // para gscemi
      const cemiterioTef =
        "0" + tef.Cemiterio?.toString()?.replace(/[^0-9]/g, "") - 0;
      if (cemiterioTef && cemiterioTef !== 0) {
        throw new Error(
          `TEF associado ao usuário não pode estar vinculado a um cemitério ${cemiterioTef}`
        );
      }

      // Salvar na sessão
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("system", selectedSystem);

      setToken(token);
      setUser(user);
      setSystem(selectedSystem);

      // precisa estar aqui para que seja considerado o token
      const responseDataParameters = await api.get("/data/parameters");
      const parameters = responseDataParameters.data;

      localStorage.setItem("parameters", JSON.stringify(parameters));

      setParameters(parameters);

      return { success: true };
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Erro ao autenticar",
      };
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("system");
    localStorage.removeItem("parameters");
    setToken(null);
    setUser(null);
    setSystem(null);
    navigate("/login");
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        token,
        system,
        loading,
        parameters,
        login,
        logout,
        isAuthenticated: !!token,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth deve ser usado dentro de um AuthProvider");
  }
  return context;
};
